import SpriteSymbol from "../../.yarn/cache/svg-baker-runtime-npm-1.4.7-fbb2e3215b-925379c771.zip/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../.yarn/cache/svg-sprite-loader-npm-6.0.11-0d03c2400c-ddbd5ea43d.zip/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "control-panel",
  "use": "control-panel-usage",
  "viewBox": "0 0 192 192",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 192 192\" id=\"control-panel\"><path d=\"M32 16v160h128V16H32zm120 152H40V24h112v144zM100 40H52v-8h48v8zm0 16H52v-8h48v8zm0 16H52v-8h48v8zm44 80a8 8 0 1 1-16 0 8 8 0 0 1 16 0zm-24 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol